import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Loader2 } from 'lucide-react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { refreshUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash;
    const params = new URLSearchParams(hash.replace('#', ''));
    const sessionId = params.get('session_id');

    if (!sessionId) {
      navigate('/login', { replace: true });
      return;
    }

    const exchangeSession = async () => {
      try {
        await axios.post(`${API}/auth/google/session`, { session_id: sessionId });
        await refreshUser();
        // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
        navigate('/dashboard', { replace: true });
      } catch (err) {
        console.error('Google auth failed:', err);
        navigate('/login?error=google_auth_failed', { replace: true });
      }
    };

    exchangeSession();
  }, [location.hash, navigate, refreshUser]);

  return (
    <div data-testid="auth-callback" className="min-h-screen bg-[#F7F2EC] flex items-center justify-center">
      <div className="text-center">
        <Loader2 className="w-8 h-8 animate-spin text-[#8C7A66] mx-auto mb-4" />
        <p className="text-[#8A7D72] font-sans text-sm">Signing you in...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
